import {Injectable} from '@angular/core';
import {ApiUrlConstants} from '@coreconstant';
import {HttpService, httpConfig} from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class EnquiryReasonService {

    baseUrlApi = ApiUrlConstants.ENQUIRY_REASON_BASE_URL;
    httpConfig: httpConfig;

    constructor(
        private _httpService: HttpService
    ) {
    }

    /**
     * Fetches the enquiry reasons by making an HTTP GET request.
     * @return {Promise} A promise that resolves to the response of the HTTP request.
     */
    getEnquiryReasons() {
        this.httpConfig = {
            url: this.baseUrlApi,
            method: 'get'
        }
        return this._httpService.init(this.httpConfig);
    }
}
